<ul class="form-wizard-list wizard-overlay">
  <li class="form-wizard-item">
    <label for="text_field_detailtitle" class="required wizard-label">Title detail</label>
    <input
      type="text"
      id="text_field_detailtitle"
      name="Title detail"
      [(ngModel)]="detail.Title"
      placeholder="set detail title without TP number."
      required
    />
  </li>
  <li class="form-wizard-item">
    <label for="text_field_detail" class="required wizard-label">Elements</label>
    <div class="form-repeat">
      <table class="form-repeat-table">
        <thead class="form-repeat-table-thead">
          <tr class="form-repeat-table-row">
            <th class="form-repeat-table-th">Choose available element(s)</th>
          </tr>
        </thead>
        <tbody class="form-repeat-table-tbody">
          <tr class="form-repeat-table-row">
            <td class="form-repeat-table-col">
              <div class="ng-select-wrapper">
                <ng-select
                  [multiple]="true"
                  [(ngModel)]="selectedElements"
                  [items]="elements | selectFields"
                  bindLabel="text"
                  bindValue="id"
                  [compareWith]="compareFn"
                  (change)="updateNgSelect($event, 'Categories')"
                  placeholder="No elements selected"
                ></ng-select>
                <span class="ngselect-icon icon is--icon-search">
                  <svg class="icon-svg">
                    <use xlink:href="/assets/gfx/svg-sprite.svg#icon-search"></use>
                  </svg>
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </li>
  <li class="form-wizard-item">
    <label for="text_field_material" class="required wizard-label">Materials</label>
    <div class="form-repeat">
      <table class="form-repeat-table">
        <thead class="form-repeat-table-thead">
          <tr class="form-repeat-table-row">
            <th class="form-repeat-table-th">Choose materials</th>
          </tr>
        </thead>
        <tbody class="form-repeat-table-tbody">
          <tr class="form-repeat-table-row">
            <td class="form-repeat-table-col">
              <div class="ng-select-wrapper">
                <ng-select
                  [multiple]="true"
                  [(ngModel)]="selectedMaterials"
                  [items]="materials | selectFields"
                  bindLabel="text"
                  bindValue="id"
                  [compareWith]="compareFn"
                  (change)="updateNgSelect($event, 'Materials')"
                  placeholder="No materials selected"
                ></ng-select>

                <span class="ngselect-icon icon is--icon-search">
                  <svg class="icon-svg">
                    <use xlink:href="/assets/gfx/svg-sprite.svg#icon-search"></use>
                  </svg>
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </li>
  <li class="form-wizard-item">
    <label for="text_field_structure" class="required wizard-label">Structures</label>
    <div class="form-repeat">
      <table class="form-repeat-table">
        <thead class="form-repeat-table-thead">
          <tr class="form-repeat-table-row">
            <th class="form-repeat-table-th">Choose structures</th>
          </tr>
        </thead>
        <tbody class="form-repeat-table-tbody">
          <tr class="form-repeat-table-row">
            <td class="form-repeat-table-col">
              <div class="ng-select-wrapper">
                <ng-select
                  [multiple]="true"
                  [(ngModel)]="selectedStructures"
                  bindLabel="text"
                  bindValue="id"
                  [compareWith]="compareFn"
                  [items]="structures | selectFields"
                  (change)="updateNgSelect($event, 'Structures')"
                  placeholder="No structures selected"
                ></ng-select>
                <span class="ngselect-icon icon is--icon-search">
                  <svg class="icon-svg">
                    <use xlink:href="/assets/gfx/svg-sprite.svg#icon-search"></use>
                  </svg>
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </li>
  <li class="form-wizard-item">
    <label for="text_field_detailtitle" class="required wizard-label">Link to CAD / Book file</label>
    <input type="text" id="text_field_detailtitle" name="Title detail" placeholder="" required [(ngModel)]="detail.FileUrl" />
  </li>
  <li class="form-wizard-item">
    <app-file-editor [files]="detail.Files" [type]="'detail'" [contentId]="detail.Id"></app-file-editor>
  </li>
  <li class="form-wizard-item">
    <button class="button variant-dark-color button-save-from" type="button" [ngClass]="{ 'is--saved': saving == true }" (click)="save()">
      Save detail
    </button>
    <button class="button button-cancel-from" type="button" (click)="onCancel.emit()">Cancel</button>
  </li>
</ul>
